import { useCallback, useEffect, useRef, useState } from 'react';
import { useAppKitAccount, useAppKit } from '@reown/appkit/react';

import {
  IChainParams,
  useLazyAuthAddNetworkQuery,
} from '../actions/addNetwork';

export const useAddNetwork = () => {
  const [chainItem, setChainItem] = useState<IChainParams>();

  const [addNetwork] = useLazyAuthAddNetworkQuery();

  const { isConnected } = useAppKitAccount();
  const { open: openConnectModal } = useAppKit();

  const isConnectedRef = useRef(isConnected);

  const handleAddNetwork = useCallback(
    async (chain: IChainParams) => {
      if (!isConnected) {
        openConnectModal();
        setChainItem(chain);
      } else {
        await addNetwork({ chain });
      }
    },
    [isConnected, addNetwork, openConnectModal],
  );

  useEffect(() => {
    const isConnectionChanged = isConnectedRef.current !== isConnected;

    if (isConnectionChanged && isConnected && chainItem) {
      addNetwork({ chain: chainItem });
    }
  }, [addNetwork, isConnectedRef, isConnected, chainItem]);

  return { handleAddNetwork };
};
